export default "__VITE_ASSET__042c4a6e__"